import {ChangeDetectorRef, Component, HostListener, OnInit, ViewChild, ViewContainerRef} from '@angular/core';
import {PopupService} from './popup.service';
import {PopupOptions} from './PopupOptions';
import {PopupClosable} from './PopupClosable';

@Component({
    selector: 'mm-popup',
    templateUrl: './popup.component.html',
    styleUrls: ['./popup.component.scss'],
    standalone: false
})
export class PopupComponent implements OnInit {
    @ViewChild('popupContent', {static: true, read: ViewContainerRef})
    public viewContainerRef!: ViewContainerRef;

    public isOpen: boolean = false;
    public popupOptions: PopupOptions = new PopupOptions();
    public workInProgress: boolean = false;

    constructor(private popupService: PopupService,
                private changeDetectorRef: ChangeDetectorRef) {
    }

    public ngOnInit(): void {
        this.popupService.initialize(this);
    }

    public setIsOpen(isOpen: boolean): void {
        this.isOpen = isOpen;
        this.changeDetectorRef.markForCheck();
    }

    public setOptions(popupOptions: PopupOptions): void {
        this.popupOptions = popupOptions;
        this.changeDetectorRef.markForCheck();
    }

    public setIsClosable(isClosable: PopupClosable): void {
        this.popupOptions.isClosable = isClosable;
        this.changeDetectorRef.markForCheck();
    }

    @HostListener('document:keydown.escape')
    public escClose(): void {
        if (!this.workInProgress && this.popupOptions.isClosable !== 'closableWithoutEsc') {
            this.close();
        }
    }

    public setWorkInProgress(state: boolean): void {
        this.workInProgress = state;
        this.changeDetectorRef.markForCheck();
    }

    @HostListener('window:popstate')
    public onPopState(): void {
        if (this.isOpen) {
            this.close();
        }
    }

    public close(): void {
        if (!this.workInProgress && this.isOpen && (this.popupOptions.isClosable === 'closable' || this.popupOptions.isClosable === 'closableWithoutEsc')) {
            this.popupService.close();
        }
    }
}
